import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, X } from "lucide-react";
import api from "@/lib/api";
import { yellowBtn } from "@/lib/airep";

export const AiQuestionsPanel = ({ deckId, onResult, onClose }) => {
  const [topic, setTopic] = useState("");
  const [audience, setAudience] = useState("");
  const [count, setCount] = useState(6);
  const [busy, setBusy] = useState(false);
  const inp = "w-full bg-white border border-slate-200 focus:border-slate-900 outline-none rounded-xl px-4 py-3 text-sm";
  const run = async () => {
    if (topic.trim().length < 3) return toast.error("Descrivi il tema dell'evento");
    setBusy(true);
    try {
      const { data } = await api.post(`/airep/decks/${deckId}/ai-questions`, { topic, audience, count });
      onResult(data.slides);
      toast.success(`${data.slides.length} domande pronte: modificale come vuoi`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Generazione non riuscita, riprova"); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-2xl border-2 border-slate-900 p-5 sm:p-6 space-y-3" data-testid="ai-questions-panel">
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5" />
        <h3 className="font-display font-bold text-lg flex-1">Genera domande con AI</h3>
        <button onClick={onClose} className="h-8 w-8 grid place-items-center rounded-lg bg-[#E3FF00]" aria-label="Chiudi" data-testid="ai-questions-close"><X className="h-4 w-4" /></button>
      </div>
      <textarea className={inp} rows={3} maxLength={500} value={topic} onChange={(e) => setTopic(e.target.value)} placeholder="Tema dell'evento, es. Convegno sugli affitti brevi: normative 2026, prezzi e tecnologia" data-testid="ai-questions-topic" />
      <div className="grid sm:grid-cols-[1fr_auto] gap-3">
        <input className={inp} maxLength={200} value={audience} onChange={(e) => setAudience(e.target.value)} placeholder="Pubblico (facoltativo), es. proprietari e property manager" data-testid="ai-questions-audience" />
        <select className={inp} value={count} onChange={(e) => setCount(Number(e.target.value))} data-testid="ai-questions-count">
          {[4, 6, 8, 10, 12].map((n) => <option key={n} value={n}>{n} domande</option>)}
        </select>
      </div>
      <p className="text-xs text-slate-500">Le domande vengono aggiunte alla presentazione e restano modificabili.</p>
      <button onClick={run} disabled={busy} className={`${yellowBtn} px-5 py-2.5 text-sm`} data-testid="ai-questions-generate">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />} {busy ? "Sto preparando le domande…" : "Genera"}
      </button>
    </div>
  );
};
